'use client';

import type { TDynamicData } from '@eliadmin/core/src/types/dynamic-data';

import { fetchDynamicSections } from '@eliadmin/core/src/api/dynamics/dynamics-api';
import { useQuery } from '@tanstack/react-query';
import { MemberCard } from '../member-card';
import { Input } from '../../ui/input';
import { useState } from 'react';
import { CiSearch } from 'react-icons/ci';
import { MembersSkeleton } from '../members-skaleton';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function MemberListTab({ locale }: { locale: string }) {
  const { t } = useTranslations();
  const [searchTerm, setSearchTerm] = useState('');

  const { data: members = [], isLoading } = useQuery({
    queryKey: ['MEMBERS', locale, searchTerm],
    queryFn: () =>
      fetchDynamicSections<TDynamicData>({
        locale,
        sectionIds: [4],
        query: {
          results: 100,
          search: searchTerm || undefined,
        },
      }),
  });

  return (
    <>
      <div className="grid w-full grid-cols-1 gap-2.5 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2">
        <Input
          type="text"
          placeholder={t('text211')}
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          before={<CiSearch size={20} className="ml-4 text-primary" />}
          className={{
            main: 'col-span-1 h-[50px] w-full rounded-full bg-black/5 pl-12 text-sm text-primary placeholder-primary',
            wrapper: 'col-span-1 h-[50px] w-full rounded-full bg-transparent',
          }}
        />
      </div>
      {isLoading ? (
        <MembersSkeleton />
      ) : (
        <div className="grid w-full grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2">
          {members.map(member => (
            <MemberCard key={member.id} member={member} />
          ))}
        </div>
      )}
    </>
  );
}
